<script>
export default {
  data() {
    return {
      csrfToken: '',
    };
  },
  mounted() {
    this.csrfToken =
      document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content') || '';
  },
};
</script>

<template>
  <!--
    Login must go through OmniAuth's request phase (/auth/google_oauth2) so the
    session and omniauth.params are primed before redirecting to Google —
    otherwise the callback can't read the auth payload back from the session.
    omniauth-rails_csrf_protection only allows POST with a valid CSRF token,
    hence the form with the authenticity_token from the csrf-token meta tag.
  -->
  <form class="flex flex-col" method="POST" action="/auth/google_oauth2">
    <input type="hidden" name="authenticity_token" :value="csrfToken" />
    <button
      type="submit"
      class="inline-flex justify-center w-full px-4 py-3 bg-n-background dark:bg-n-solid-3 rounded-md shadow-sm ring-1 ring-inset ring-n-container dark:ring-n-container focus:outline-offset-0 hover:bg-n-alpha-2 dark:hover:bg-n-alpha-2"
    >
      <span class="i-logos-google-icon h-6" />
      <span class="ml-2 text-base font-medium text-n-slate-12">
        {{ $t('LOGIN.OAUTH.GOOGLE_LOGIN') }}
      </span>
    </button>
  </form>
</template>
